export * from './footerSlice';
export * from './footerSelectors';
